import { createAction } from 'redux-actions'

import { actionCreators as api } from 'reduxBits/api'
import { actionCreators as notificationActions } from 'reduxBits/notifications'

const prefix = 'Phone Number:'
export const REQUEST_VIEW_PHONE_NUMBER = `${prefix} Request view phone.`
export const RECEIVE_VIEW_PHONE_NUMBER = `${prefix} Update the state with the fetched phone number`
export const CALLED_NUMBER = `${prefix} User initated a phone call`

const requestViewPhoneNumber = createAction(REQUEST_VIEW_PHONE_NUMBER)
const receiveViewPhoneNumber = createAction(
  RECEIVE_VIEW_PHONE_NUMBER,
  (payload) => payload,
  (_payload, adId) => adId,
)

const calledNumber = createAction(CALLED_NUMBER)

const fetchPhoneNumber = (adId) => async (dispatch) => {
  const url = `search_bff/v1/content/${adId}/phone_numbers`
  dispatch(requestViewPhoneNumber())

  const response = await dispatch(api.fetch(url))

  if (response.ok) {
    dispatch(receiveViewPhoneNumber(response.textOrJson, adId))
    return response.textOrJson
  }

  dispatch(receiveViewPhoneNumber(response, adId))

  // If we don't have `textOrJson` we didn't get a response from the backend
  // probably due to the user has an ad blocker installed.
  // Show a general error
  if (!response.textOrJson) {
    dispatch(
      notificationActions.addErrorNotification(
        'Något gick fel! Försök igen eller kontakta kundservice.',
        null,
      ),
    )
  } else if (response.textOrJson.error === 'phoneview_do_not_show_number') {
    dispatch(
      notificationActions.addErrorNotification('Telefonnumret kan inte visas just nu.', null),
    )
  }

  throw response
}

export const actionCreators = {
  fetchPhoneNumber,
  calledNumber,
}
